import { useExperimentalFeature } from "@istari-frontend/experimental-features";
import type { ReactNode } from "react";
import { Navigate } from "react-router";

import { routes } from "~/routes";
import { useSession } from "~/session";

import type { SettingsEntry } from "./settings-entries";
import { buildSettingsGuardContext, settingsRouteAllowsEntry } from "./settings-guard-context";
import { settingsGuardRedirectState } from "./settings-guard-redirect-state";

interface SettingsEntryRouteProps {
  entry: SettingsEntry;
  children: ReactNode;
}

export function SettingsEntryRoute({ entry, children }: SettingsEntryRouteProps) {
  const session = useSession();
  const { enabled: aiChatEnabled } = useExperimentalFeature("ai-chat");
  const context = buildSettingsGuardContext(session, aiChatEnabled);

  if (!settingsRouteAllowsEntry(entry, context)) {
    return <Navigate to={routes.SettingsProfile} replace state={settingsGuardRedirectState(entry.id)} />;
  }

  return children;
}
